/**
 * External Sign-In Helper
 *
 * Utility for external applications to redirect to sign-in
 * This can be used from other domains/ports
 *
 * Usage from external app:
 * ```javascript
 * // From localhost:3001 wanting to sign in via localhost:3000
 * window.location.href = 'http://localhost:3000/signin?returnUrl=' +
 *   encodeURIComponent(window.location.href);
 * ```
 */
export const EXTERNAL_SIGNIN_HELPER = {
  /**
   * Create a redirect URL for external applications
   * @param {string} currentUrl - Current URL of external app
   * @param {string} signInBaseUrl - Your sign-in page URL
   * @returns {string} - URL to redirect to
   */
  createRedirectUrl: (
    currentUrl,
    signInBaseUrl = "http://localhost:3000/signin",
  ) => {
    const url = new URL(signInBaseUrl);
    url.searchParams.set("returnUrl", encodeURIComponent(currentUrl));
    return url.toString();
  },

  /**
   * Example usage snippet for external applications
   */
  getUsageExample: () => `
// Add this to your external app's sign-in button:
const redirectToSignIn = () => {
  const returnUrl = encodeURIComponent(window.location.href);
  window.location.href = \`http://localhost:3000/signin?returnUrl=\${returnUrl}\`;
};

// Or use the helper:
import { EXTERNAL_SIGNIN_HELPER } from './redirectUtils.js';
const redirectUrl = EXTERNAL_SIGNIN_HELPER.createRedirectUrl(window.location.href);
window.location.href = redirectUrl;
  `,
};
